/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FavoriteAccountRequest {
  /**
   * Идентификатор счета
   * @format uuid
   */
  accountId: string;
}

/**
 * Код ошибки
 */
export enum ErrorCode {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  PARSING_ERROR = "PARSING_ERROR",
  NOT_FOUND_ERROR = "NOT_FOUND_ERROR",
  ALREADY_EXIST = "ALREADY_EXIST",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
}

export interface ErrorInfo {
  /**
   * Сообщение об ошибке
   * @example Ошибка обработки объекта
   */
  message: string;

  /** Код ошибки */
  errorCode: ErrorCode;
}

/**
 * Настройки
 */
export interface SettingsItem {
  /** Идентификатор системы владельца */
  systemId: string;

  /** Ключ свойства */
  key: string;

  /** Значение свойства по умолчанию */
  defaultValue?: string;

  /** Значение свойства */
  value?: string;

  /** Описание свойства */
  description: string;

  /** Тип настройки(STRING, INT, FLOAT, BOOLEAN) */
  propertyType?: string;

  /** Код типа настройки */
  propertyTypeSignature?: string;
}

export interface ClientSettings {
  /** Настройки */
  settings: Record<string, SettingsItem[]>;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title МС Настройки
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-plt-ms-settings.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Микросервис настроек, внешние клиентские настройки
     * @name SetFavoriteAccount
     * @summary Установить признак избранного счета
     * @request POST:/api/settings/external/v1/account/favorite-account
     * @secure
     */
    setFavoriteAccount: (
      data: FavoriteAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, void | ErrorInfo>({
        path: `/api/settings/external/v1/account/favorite-account`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Микросервис настроек, внешние клиентские настройки
     * @name DeleteFavoriteAccount
     * @summary Удалить признак избранного счета
     * @request DELETE:/api/settings/external/v1/account/favorite-account
     * @secure
     */
    deleteFavoriteAccount: (
      data: FavoriteAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, void | ErrorInfo>({
        path: `/api/settings/external/v1/account/favorite-account`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Микросервис настроек, external функции
     * @name GetPublicProperties
     * @summary Получение публичных настроек
     * @request GET:/api/settings/v1/external/setting
     */
    getPublicProperties: (params: RequestParams = {}) =>
      this.request<SettingsItem[], any>({
        path: `/api/settings/v1/external/setting`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Микросервис настроек, external функции
     * @name GetClientExternalSettings
     * @summary Получение публичных настроек для клиентов
     * @request GET:/api/settings/external/v1/client-settings
     * @secure
     */
    getClientExternalSettings: (
      query?: { propertyTypeSignatures?: string[] },
      params: RequestParams = {}
    ) =>
      this.request<ClientSettings, void | ErrorInfo>({
        path: `/api/settings/external/v1/client-settings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
